import Vue from 'vue';
import VueRouter from 'vue-router';
import routes from './routes';

Vue.use(VueRouter);

let router = new VueRouter({
    mode: 'history',
    linkActiveClass: 'is-active',
    routes
});

router.beforeEach((to, from, next) => {
    if (window._hmt && to.path) {
        window._hmt.push(['_trackPageview', to.fullPath]);
    }
    next();
});

export default router;
